export const initialState = {
  actionProcessing: false,
  currentGifts: {
    items: [],
    count: 0,
  },
  currentGiftsUpdateTrigger: {},
};
